// SAFFROONI theme scripts — scroll reveal to match the live site's motion feel
document.addEventListener('DOMContentLoaded', function () {
  // Product gallery: clicking a thumbnail swaps the main image
  var mainPhoto = document.getElementById('ProductPhoto');
  var thumbs = document.querySelectorAll('.product-main__thumb');
  if (mainPhoto && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc) {
          mainPhoto.src = fullSrc;
          mainPhoto.srcset = '';
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var revealTargets = document.querySelectorAll(
    '.section-head, .product-card, .product-main__gallery, .product-main__info, .collection-header'
  );

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  revealTargets.forEach(function (el, i) {
    el.classList.add('reveal');
    // Stagger cards within the same grid (product/journal grids) like the live site's list animations
    var group = el.closest('.product-grid');
    if (group) {
      var siblings = Array.prototype.indexOf.call(group.children, el);
      el.style.transitionDelay = (Math.min(siblings, 6) * 70) + 'ms';
    }
    io.observe(el);
  });
});

// ---------- Related products (Shopify native recommendations, Amazon-style shelf) ----------
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.related-products');
  var grid = document.getElementById('RelatedProductsGrid');
  if (!section || !grid) return;

  var productId = section.getAttribute('data-product-id');
  var limit = section.getAttribute('data-limit') || 6;
  var currency = grid.getAttribute('data-currency') || 'CAD';
  var locale = document.documentElement.lang || 'en';

  var moneyFormatter;
  try {
    moneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
  } catch (e) {
    moneyFormatter = { format: function (v) { return '$' + v.toFixed(2); } };
  }

  var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
    '&limit=' + encodeURIComponent(limit) + '&intent=related';

  fetch(url)
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (data) {
      if (!data || !data.products || !data.products.length) {
        section.style.display = 'none';
        return;
      }

      data.products.forEach(function (p) {
        var price = moneyFormatter.format((p.price || 0) / 100);
        var soldOut = !p.available;
        var images = p.images || [];
        var primaryImg = p.featured_image || images[0] || '';
        var secondaryImg = images.length > 1 ? images[1] : null;
        var cardClasses = 'product-card product-card--compact' +
          (soldOut ? ' product-card--soldout' : '') +
          (secondaryImg ? '' : ' product-card--single-image');

        var card = document.createElement('div');
        card.className = cardClasses;
        var altText = (p.title || '').replace(/"/g, '&quot;');
        card.innerHTML =
          '<a href="' + p.url + '" class="product-card__image-wrap">' +
            (primaryImg ? '<img class="product-card__image product-card__image--primary" src="' + primaryImg + '" alt="' + altText + '" loading="lazy">' : '') +
            (secondaryImg ? '<img class="product-card__image product-card__image--secondary" src="' + secondaryImg + '" alt="' + altText + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="product-card__body">' +
            '<div>' +
              '<a href="' + p.url + '"><h3>' + p.title + '</h3></a>' +
              '<p class="product-card__price">' + (soldOut ? '' : price) + '</p>' +
            '</div>' +
          '</div>';
        grid.appendChild(card);
      });

      // Apply the same scroll-reveal treatment as the rest of the theme
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io2.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

        Array.prototype.forEach.call(grid.children, function (el, i) {
          el.classList.add('reveal');
          el.style.transitionDelay = (Math.min(i, 6) * 70) + 'ms';
          io2.observe(el);
        });
      }
    })
    .catch(function () {
      section.style.display = 'none';
    });
});

// ---------- Cart: quantity stepper, remove button, live AJAX updates ----------
document.addEventListener('DOMContentLoaded', function () {
  // Delegated on document so it keeps working after CartItemsRoot is replaced with fresh HTML.
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('.qty-btn--minus');
    var plus = e.target.closest('.qty-btn--plus');
    var remove = e.target.closest('.cart-remove');

    if (minus || plus) {
      var stepper = (minus || plus).closest('.qty-stepper');
      if (!stepper) return;
      var input = stepper.querySelector('.qty-input');
      var current = parseInt(input.value, 10) || 0;
      var next = minus ? Math.max(0, current - 1) : current + 1;
      input.value = next;
      cartChangeLine(stepper.getAttribute('data-cart-key'), next);
    }

    if (remove) {
      cartChangeLine(remove.getAttribute('data-cart-key'), 0);
    }
  });

  // Manual typing into the qty field also triggers a live update.
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.qty-input')) {
      var stepper = e.target.closest('.qty-stepper');
      if (!stepper) return;
      var qty = Math.max(0, parseInt(e.target.value, 10) || 0);
      e.target.value = qty;
      cartChangeLine(stepper.getAttribute('data-cart-key'), qty);
    }
  });

  function getCartRoot() {
    return document.getElementById('CartItemsRoot');
  }

  function setCartRootBusy(isBusy) {
    var root = getCartRoot();
    if (root) root.style.opacity = isBusy ? '0.5' : '';
  }

  function cartChangeLine(key, quantity) {
    if (!key) return;
    setCartRootBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCountBadge(cart.item_count);
        return refreshCartSection();
      })
      .catch(function () {
        setCartRootBusy(false);
        // Fall back to a full reload if the AJAX call fails, so the cart is never left out of sync.
        window.location.reload();
      });
  }

  function refreshCartSection() {
    var root = getCartRoot();
    if (!root) return Promise.resolve();
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    return fetch(cartUrl + '?sections=main')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data && data.main;
        if (!html) { window.location.reload(); return; }
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newRoot = doc.getElementById('CartItemsRoot');
        var oldRoot = getCartRoot();
        if (newRoot && oldRoot) {
          oldRoot.replaceWith(newRoot);
        }
      });
  }

  function updateCartCountBadge(itemCount) {
    var badge = document.querySelector('.cart-count');
    var icon = document.querySelector('.cart-icon');
    if (!icon) return;
    if (itemCount > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        icon.appendChild(badge);
      }
      badge.textContent = itemCount;
    } else if (badge) {
      badge.remove();
    }
  }
});

// ---------- Promo popup: show once per session, after a short delay ----------
document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('PromoPopup');
  if (!popup) return;

  var SESSION_KEY = 'saffrooniPromoShown';
  try {
    if (sessionStorage.getItem(SESSION_KEY)) return;
  } catch (e) {
    // sessionStorage unavailable (privacy mode) — fall through and show once anyway.
  }

  var delay = parseInt(popup.getAttribute('data-delay'), 10) || 4000;
  var openTimer = setTimeout(openPopup, delay);

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  function closePopup() {
    clearTimeout(openTimer);
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  Array.prototype.forEach.call(popup.querySelectorAll('[data-promo-close]'), function (el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  var copyBtn = popup.querySelector('[data-promo-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-code') || '';
      var copiedLabel = copyBtn.getAttribute('data-copied-label') || 'Copied';
      var originalLabel = copyBtn.getAttribute('data-original-label');
      if (originalLabel === null) {
        originalLabel = copyBtn.textContent.trim();
        copyBtn.setAttribute('data-original-label', originalLabel);
      }

      function markCopied() {
        copyBtn.textContent = copiedLabel;
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          copyBtn.textContent = originalLabel;
          copyBtn.classList.remove('is-copied');
        }, 2000);
      }

      function fallbackCopy() {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        markCopied();
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(markCopied).catch(fallbackCopy);
      } else {
        fallbackCopy();
      }
    });
  }
});

